export default {
      id: "icon-rounded-arrow-usage",
      viewBox: "0 0 17 15",
      url: __webpack_public_path__ + "icons.svg#icon-rounded-arrow",
      toString: function () {
        return this.url;
      }
    }